import 'rxjs/add/operator/debounceTime';
import {Component, ElementRef, ViewChild} from '@angular/core';
import {Content, Header, NavController, NavParams, ViewController} from 'ionic-angular';

import {SocialSharing} from "@ionic-native/social-sharing";

import {CONFIG} from '../../../app/config';
import {TGoogleAnalytic, TModalAlert, TStatusBar, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {WebstorService} from "../../../providers/webstor-service";
import {HotspotService} from "../../../providers/hotspot-service";
import {
    TAction,
    TBrandedTipo,
    TGeradorFlag,
    TGeradorLine,
    TPaybookFato,
    TFinanceSide,
    THotspotFlag,
    TProfileTeam,
    TMonth,
    TRuleValue,
    TVersionBeta,
    TImageModel,
    TUsuarioRole,
    TContatoTipo,
    TPrecifyMenu,
    TPrinterBind,
    TProfileAlma,
    TEstoqueView,
    TMonitorDoby,
    TMonitorUnir,
} from "../../../app/enum";
import {ModalActionPage} from "../modal-action/modal-action";
import {GeradorMenuPage} from "../gerador-menu/gerador-menu";
import {UnidadeMenuPage} from "../unidade-menu/unidade-menu";
import {NegocioMenuPage} from "../negocio-menu/negocio-menu";
import {ProfileMenuPage} from "../profile-menu/profile-menu";
import {WebstorOpenPage} from "../webstor-open/webstor-open";
import {ListingMenuPage} from "../listing-menu/listing-menu";
import {MonitorDeskPage} from "../monitor-desk/monitor-desk";
import {ProfileService} from '../../../providers/profile-service';
import {ProfileRepository} from '../../../repositories/profile-repository';

export enum TWorkdayShut {wsEmissor, wsQuitado, wsDevedor}
@Component({
    selector: 'page-setting-menu',
    templateUrl: 'setting-menu.html',
    providers: [WebstorService, HotspotService, ProfileService, ProfileRepository]
})
export class SettingMenuPage {

    config: any;

    //Hotspot - etapa 0
    THotspotFlag: any = THotspotFlag;
    TPrecifyMenu: any = TPrecifyMenu;
    
    
    //Setting - etapa 1
    TWorkdayShut: any = TWorkdayShut;
    TVersionBeta: any = TVersionBeta;
    TProfileAlma: any = TProfileAlma;
    TPrinterBind: any = TPrinterBind;
    TEstoqueView: any = TEstoqueView;
    TMonitorDoby: any = TMonitorDoby;
    TMonitorUnir: any = TMonitorUnir;
    debouncedTime: number;

    hotspotDedo: boolean;


    logado: any;
    rootile: any;
    pulsed: boolean;

    etapa: number;
    userset: any;

    branded: any;
    rootspot: any;
    copyspot: any;

    detail: boolean;

    headedit: boolean;
    turnedit: boolean;

    notaedit: boolean;

    ambientIX: number = 0;
    _setuper: number = 0;


    @ViewChild(Header) header: Header;
    @ViewChild(Content) content: Content;
    @ViewChild('pulsedItem') pulsedElement: ElementRef;

    constructor(private viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams,
                public util: Util, private socialSharing: SocialSharing,
                public webstorService: WebstorService, public hotspotService: HotspotService,
                public logadoService: LogadoService, public profileRepository: ProfileRepository) {

        this.pulsed = false;
        this.config = CONFIG;

        this.detail = false;

        this.logado = this.logadoService.getAuth();
        this.rootile = this.navParams.get('rootile');

        this.etapa = this.navParams.get('etapa');
        this.userset = this.navParams.get('userset');

        this.rootspot = this.navParams.get('rootspot');
        this.copyspot = this.navParams.get('copyspot');

        this.branded = this.navParams.get('branded');

        this.notaedit = this.userset.FlagTeam && !!this.copyspot.Hotspots[0].HotspotText;

        this.hotspotDedo = (this.copyspot.Hotspots[0].Setting.SettingDedo > 0);

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Setting Menu', '/setting-menu');

        if (this.etapa == 0) this.settingLoad();
        if (this.etapa == 1) this._setuper = 0;

    }

    getTitle(): string {

        if (!this.copyspot) return 'Hotspot';

        if (this.etapa == 0) return this.copyspot.Hotspots[0].Branded.BrandedShow; //'Configuração';
        if (this.etapa == 1) return 'Setup';
        if (this.etapa == 2) return 'Workday';

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    debounced(back?) {

        if (back) {
            this.debouncedTime = 0;
            this.util.populateObj(this.copyspot, this.rootspot);
        }

        setTimeout(() => this.debouncedTime = 1500, 2000);

    }

    settingLoad() {

        this.pulsePressed();

        //Mailpay
        if (!this.notaedit) this.debounced();

    }

    monitorOpen() {

        let object = {etapa: 5, hotspotID: this.copyspot.Hotspots[0].HotspotID};
        this.util.modalopen(MonitorDeskPage, 'alto', false, object).subscribe();

    }

    hotspotSave(that: any = null) {

        let json = this.copyspot.Hotspots[0];

        let loading = this.util.loadingDots();
        loading.present();

        let mbteam = (this.rootile.Profile.ProfileTeam >= TProfileTeam.mkManager);
        let action = (mbteam ? TAction.acSave : TAction.acEdit);

        this.hotspotService.hotspot(action, this.copyspot.Hotspots[0].HotspotID, this.rootile.Profile.ProfileID, json)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    this.notaedit = false;
                    this.debounced();

                    this.util.populateObj(this.rootspot, this.copyspot);
                    if (that) that.dismiss();

                },
                erro => {

                    this.util.alertPopula(erro, this.rootspot, this.copyspot, () => this.debounced(true));

                });

    }

    pulsePressed() {

        if (!this.pulsedElement) return;

        let handle;
        handle = setInterval(() => {

            let heightComp = this.pulsedElement.nativeElement.getBoundingClientRect().top;
            let heightHead = this.header.getNativeElement().clientHeight;
            let heightWind = window.innerHeight;
            this.pulsed = (heightComp > heightHead && heightComp < heightWind);

            if (this.pulsed) {
                clearInterval(handle);
                setTimeout(() => this.pulsed = false, 2000);
            }

        }, 1000);

    }

    hotspotNota() {

        this.notaedit = true;
        this.debouncedTime = 0;
    
    }

    hotspotText() {

        if (!this.userset.FlagZito || this.copyspot.Hotspots[0].HotspotText == this.rootspot.Hotspots[0].HotspotText) {
            this.notaedit = false;
            this.debounced(true);
            return;
        }

        this.hotspotSave();

    }

    hotspotFlag() {

        if (!this.userset.FlagZito) {
            this.util.toastSimply('Acesso Negado');
            return;
        }

        let onNext = (flag) => {

            //if (flag != THotspotFlag.hfHotspotAberto)
            this.copyspot.Hotspots[0].HotspotFree = '';
            this.copyspot.Hotspots[0].HotspotFlag = flag;
            this.hotspotSave();

        };

        /** OPEN **/
        let arrayEnum = this.util.enumArray(THotspotFlag, THotspotFlag.hfHotspotAberto);
        let buttons: Array<any> = [];
        arrayEnum.forEach(flag => buttons.push({text: flag.slice(9, 99), handler: () => onNext(THotspotFlag[flag])}));
        this.util.sheetOpen(buttons, 'STATUS');

    }



    /** ************************************************ HOTSPOT ************************************************** **/
    /** ************************************************ setuper ************************************************** **/

    profileMenu(line) {

        let object = {profileSpot: true, profileID: line.ProfileID, rootile: null};
        this.util.modalopen(ProfileMenuPage, 'alto', false, object).subscribe();

    }

    ambientMenu(recinto, index) {

        if (!this.userset.FlagTeam) {
            this.util.alertSimply('Contate o support para alterar ou criar');
            return;
        }

        /** OPEN **/
        let lixo = (index > 0 && index == this.copyspot.Hotspots[0].Recintos.length-1);
        let buttons: Array<any> = [];
                  buttons.push({text: 'Alterar',  handler: () => this.ambientOpen(recinto)});
        if (lixo) buttons.push({text: 'Excluir',  handler: () => this.recintoLixo(index), role: 'destructive'});
        this.util.sheetOpen(buttons, 'AMBIENTE', 0);

    }

    ambientOpen(recinto) {

        let onSave = (data) => {
            
            //NO-CHANGE
            if (recinto && recinto.Ambient.AmbientID == data.AmbientID) return;

            let exist = this.copyspot.Hotspots[0].Recintos.find(RE => RE.Ambient.AmbientID == data.AmbientID);
            if (exist && (!recinto || recinto.Ambient.AmbientID != data.AmbientID)) {
                this.util.toastSimply('Ambiente já está adicionado');
                return;
            }

            if (!recinto) {
                let recintoQtde = (this.copyspot.Hotspots[0].Recintos.length + '');
                recinto = this.util.deepCopy(this.copyspot.Hotspots[0].Recintos[0]);
                recinto.RecintoID = parseInt(this.copyspot.Hotspots[0].HotspotID + recintoQtde);
                this.copyspot.Hotspots[0].Recintos.push(recinto);
                this.ambientIX = this.copyspot.Hotspots[0].Recintos.length-1;
            }

            this.util.populateObj(recinto.Ambient, data);

            this.recintoSave(recinto);

        };

        let object = {homeb: false, etapa: 1, title: null, keyname: 'Ambient', toggler: 'line', rootspot: this.rootspot};
        this.util.modalopen(WebstorOpenPage, 'alto', false, object).subscribe(data => onSave(data[0]));

    }

    pracetaLixo(index) {

        let line = this.copyspot.Hotspots[0].Recintos[this.ambientIX];

        line.RecintoRoom.splice(index, 1);
        if (line.RecintoRoom.length == 0) line.RecintoRoom = null;

        this.recintoSave(line);

    }

    pracetaMenu(index) {

        /** OPEN **/
        let lixo = (index >= 0);
        let buttons: Array<any> = [];
                  buttons.push({text: 'Nome',     handler: () => this.pracetaOpen(index)});
                  buttons.push({text: 'Qtde',     handler: () => this.pracetaQtde(index, null)});
        if (lixo) buttons.push({text: 'Excluir',  handler: () => this.pracetaLixo(index), role: 'destructive'});
        this.util.sheetOpen(buttons, 'PRAÇA', 0);

    }

    pracetaQtde(index, pracetaNome) {

        let line = this.copyspot.Hotspots[0].Recintos[this.ambientIX];
        let room = (index < 0 ? null : line.RecintoRoom[index]);

        let onSave = (qtde) => {

            let novo = (room == null);
            if (novo) {
                room = {Name: '', Qtde: 0};
                if ( line.RecintoRoom) line.RecintoRoom.push(room);
                if (!line.RecintoRoom) line.RecintoRoom = [room];
            }

            room.Name = pracetaNome ? pracetaNome : room.Name;
            room.Qtde = qtde;

            this.recintoSave(line);
        };

        let buttons: Array<any> = [];
        for (let i = 1; i <= 100; i++) buttons.push({text: i, value: i});

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = room ? (room.Qtde - 1) : 0;
        this.util.pickerOpen(columns, onSave);

    }

    pracetaOpen(index) {

        let line = this.copyspot.Hotspots[0].Recintos[this.ambientIX];
        let room = (index < 0 ? null : line.RecintoRoom[index]);

        let onPrca = (prca) => {

            if (line.RecintoRoom) {
                let exist = line.RecintoRoom.find((RM, IX) => RM.Name == prca.PracetaNome && IX != index);
                if (exist) {
                    this.util.toastSimply('Praça já está adicionada');
                    return;
                }    
            }

            if (room) {
                room.Name = prca.PracetaNome;
                this.recintoSave(line);
            }

            if (!room) this.pracetaQtde(index, prca.PracetaNome);
    
        };

        let object = {homeb: false, etapa: 1, title: null, keyname: 'Praceta', toggler: 'line', rootspot: this.rootspot};
        this.util.modalopen(WebstorOpenPage, 'alto', false, object).subscribe(data => onPrca(data[0]));

    }

    empresaFind(index) {

        let ghosterID = this.copyspot.Hotspots[0].Branded.BrandedID;
        this.profileRepository.profileFind(null, 'CNPJ', ProfileMenuPage, ghosterID, true)
            .subscribe(
                lino => {
                    if (index < 0) {
                        index = this.copyspot.Hotspots[0].Empresas.findIndex(EM => (EM.ProfileID == lino.ProfileID));
            
                        if (index < 0) {
                            let empresaQtde = (this.copyspot.Hotspots[0].Empresas.length + '');
                            let empresaID = parseInt(this.copyspot.Hotspots[0].HotspotID + empresaQtde);
                            let empresa = {EmpresaID: empresaID, Profile: lino};
                            this.copyspot.Hotspots[0].Empresas.push(empresa);
                            index = this.copyspot.Hotspots[0].Empresas.length-1;
                        }
                    }

                    this.copyspot.Hotspots[0].Empresas[index].Profile = lino;
                    setTimeout(() => this.empresaSave(this.copyspot.Hotspots[0].Empresas[index]), 800);
                });

    }

    recintoLixo(index) {

        let erro = '';
        if (!erro && index == 0) erro = 'Recinto principal não pode ser removido';
        if (!erro && index != this.copyspot.Hotspots[0].Recintos.length-1) erro = 'Somente a última empresa pode ser removida';
        if (erro) {
            this.util.toastSimply(erro);
            return;
        };


        this.util.alertObserv('DELETE', 'Deseja remover o ambiente?', 'Excluir', false, TModalAlert.maDanger).subscribe(
            () => {

                //Requisicao...
                let loading = this.util.loadingDots();
                loading.present();
                this.hotspotService.recinto(TAction.acLixo, 0, this.copyspot.Hotspots[0].HotspotID, this.copyspot.Hotspots[0].Recintos[index].RecintoID)
                    .finally(() => loading.dismiss())
                    .subscribe(
                        data => {
        
                            this.ambientIX = 0;
                            setTimeout(() => {
                                this.rootspot.Hotspots[0].Recintos.splice(index, 1);
                                this.copyspot.Hotspots[0].Recintos.splice(index, 1);
                            }, 500);
        
                        },
                        erro => {
        
                            this.util.alertPopula(erro, this.rootspot, this.copyspot, () => this.debounced(true));
        
                        });
        
            },
            () => {});

    }

    empresaSave(line) {

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.empresa(TAction.acSave, 0, this.copyspot.Hotspots[0].HotspotID, line.EmpresaID, line)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    this.util.populateObj(this.rootspot, this.copyspot);

                },
                erro => {

                    this.util.alertPopula(erro, this.rootspot, this.copyspot, () => this.debounced(true));

                });

    }

    recintoSave(line) {
        
        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.recinto(TAction.acSave, 0, this.copyspot.Hotspots[0].HotspotID, line.RecintoID, line)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    this.util.populateObj(this.rootspot, this.copyspot);

                },
                erro => {

                    this.util.alertPopula(erro, this.rootspot, this.copyspot, () => this.debounced(true));

                });
        
    }

    empresaLixo(index) {

        let erro = '';
        if (!erro && index == 0) erro = 'Empresa principal não pode ser removida';
        if (!erro && index != this.copyspot.Hotspots[0].Empresas.length-1) erro = 'Somente a última empresa pode ser removida';
        if (!erro && this.copyspot.Hotspots[0].EmpresaID == this.copyspot.Hotspots[0].Empresas[index].Profile.ProfileID) erro = 'Empresa está em uso';
        if (erro) {
            this.util.toastSimply(erro);
            return;
        };


        this.util.alertObserv('DELETE', 'Deseja remover a empresa?', 'Excluir', false, TModalAlert.maDanger).subscribe(
            () => {

                //Requisicao...
                let loading = this.util.loadingDots();
                loading.present();
                this.hotspotService.empresa(TAction.acLixo, 0, this.copyspot.Hotspots[0].HotspotID, this.copyspot.Hotspots[0].Empresas[index].EmpresaID)
                    .finally(() => loading.dismiss())
                    .subscribe(
                        data => {
        
                            this.rootspot.Hotspots[0].Empresas.splice(index, 1);
                            this.copyspot.Hotspots[0].Empresas.splice(index, 1);
        
                        },
                        erro => {
        
                            this.util.alertPopula(erro, this.rootspot, this.copyspot, () => this.debounced(true));
        
                        });
        
            },
            () => {});

    }

    empresaSwap(index) {

        this.copyspot.Hotspots[0].EmpresaID = this.copyspot.Hotspots[0].Empresas[index].Profile.ProfileID;
        this.hotspotSave(null);

    }

    empresaSpot() {

        return this.copyspot.Hotspots[0].Empresas.filter(EM => EM.Profile.ProfileID == this.copyspot.Hotspots[0].EmpresaID)[0];

    }

    empresaOpen() {

        let onDone = (index) => {

            let team = this.userset.FlagTeam;
            let lixo = this.userset.FlagTeam && index > 0 && index == this.copyspot.Hotspots[0].Empresas.length-1;
            let frst = this.userset.FlagTeam && index == 0;
            let qtde = (this.copyspot.Hotspots[0].Empresas.length > 1) || !this.empresaSpot();

            /** OPEN **/
            let buttons: Array<any> = [];
            if (team) buttons.push({text: 'Editar', handler: () => this.profileMenu(this.copyspot.Hotspots[0].Empresas[index].Profile)});
            if (frst) buttons.push({text: 'Trocar', handler: () => this.empresaFind(index)});
            if (qtde) buttons.push({text: 'Emitir', handler: () => this.empresaSwap(index)});
            if (lixo) buttons.push({text: 'Delete', handler: () => this.empresaLixo(index), cssClass: this.util.sheetClass(true, true, 'food')});
            this.util.sheetOpen(buttons, 'EMPRESA');

        }
        
        /** OPEN **/
        let buttons: Array<any> = [];
        this.copyspot.Hotspots[0].Empresas.forEach((EM, index) => buttons.push({text: EM.Profile.ProfileRnid, handler: () => onDone(index)}));
        this.util.sheetOpen(buttons, 'EMPRESA');

    }

    recintoMenu() {

        let line = this.copyspot.Hotspots[0].Recintos[this.ambientIX];

        let onDone = (menu) => {
            line.RecintoMenu = menu;
            this.recintoSave(line);
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Normal',   handler: () => onDone(TPrecifyMenu.pcNormal)});
        buttons.push({text: 'Popular',  handler: () => onDone(TPrecifyMenu.pcPopular)});
        buttons.push({text: 'Especial', handler: () => onDone(TPrecifyMenu.pcEspecial)});
        this.util.sheetOpen(buttons, 'PREÇO');

    }

    recintoGorj() {

        let line = this.copyspot.Hotspots[0].Recintos[this.ambientIX];

        let onGorj = (gorj) => {
            line.RecintoGorj = gorj;
            this.recintoSave(line);
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: '0%',   handler: () => onGorj(0)});
        buttons.push({text: '10%',  handler: () => onGorj(10)});
        buttons.push({text: '12%',  handler: () => onGorj(12)});
        buttons.push({text: '13%',  handler: () => onGorj(13)});
        buttons.push({text: '14%',  handler: () => onGorj(14)});
        buttons.push({text: '15%',  handler: () => onGorj(15)});
        this.util.sheetOpen(buttons, 'PREÇO');
        
    }

    recintoObar() {

        let line = this.copyspot.Hotspots[0].Recintos[this.ambientIX];
        let init = this.copyspot.Hotspots[0].HotspotTurn;

        let onSave = (root, reet) => {
            line.RecintoObar = root;
            this.recintoSave(line);
        };

        let buttons: Array<any> = [];
        let inc = 0;
        let selectedIndex = 0;
        buttons.push({text: 'Sempre disponível',  value: init});
        for (let i = init+1; i <= 23; i = i + 1) {
            inc++
            if (line.RecintoObar == i) selectedIndex = inc;
            buttons.push({text: 'após as ' + i + 'h', value: i})
        };

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = selectedIndex;
        this.util.pickerOpen(columns, onSave);
        
    }

    recintoRoom() {
        
        let line = this.copyspot.Hotspots[0].Recintos[this.ambientIX];

        /** OPEN **/
        let buttons: Array<any> = [];
        if (line.RecintoRoom) line.RecintoRoom.forEach((RM, index) => buttons.push({text: '(' + RM.Qtde + ') ' + RM.Name,   handler: () => this.pracetaMenu(index)}));
        if (!line.RecintoRoom || line.RecintoRoom.length < 4) buttons.push({text: 'ADICIONAR', cssClass: this.util.sheetClass(), handler: () => this.pracetaOpen(-1)});
        this.util.sheetOpen(buttons, 'PRAÇA');

    }



    /** ************************************************ HOTSPOT ************************************************** **/
    /** ************************************************ etapa-0 ************************************************** **/

    settingFlug(flug: 'cent' | 'text') {

        if (!this.copyspot.Contatos) return 0;

        let tagMail = this.copyspot.Contatos.filter(contato => contato.ContatoRede == TContatoTipo.coMail).length;
        let tagChip = this.copyspot.Contatos.filter(contato => contato.ContatoRede == TContatoTipo.coChip).length;
        let tagFace = this.copyspot.Contatos.filter(contato => contato.ContatoRede == TContatoTipo.coFace).length;
        let tagInst = this.copyspot.Contatos.filter(contato => contato.ContatoRede == TContatoTipo.coInst).length;
        let tagTube = this.copyspot.Contatos.filter(contato => contato.ContatoRede == TContatoTipo.coTube).length;
        let tagWifi = 0;
        let cent = (tagMail + tagChip + tagFace + tagInst + tagTube) * 20;

        if (flug == 'text' && !tagFace) return 'Configure o Facebook para divulgar.';
        if (flug == 'text' && !tagInst) return 'Configure o Instagram para divulgar.';
      //if (flug == 'text' && !tag) return 'Escreva um texto sobre seu negócio.';
        if (flug == 'text' && !tagWifi) return 'Você ainda não preencheu o Wifi.';

        return cent;

    }

    settingTurn() {

        if (this.copyspot.Hotspots[0].HotspotTurn == this.rootspot.Hotspots[0].HotspotTurn) return;

        
        //OpenbarTurn -> acompanha o HotspotTurn
        this.copyspot.Hotspots[0].Recintos.forEach(RE => {
            let copyTurn = this.rootspot.Hotspots[0].HotspotTurn;
            let saveTurn = this.copyspot.Hotspots[0].HotspotTurn;
            if (RE.RecintoObar == copyTurn) RE.RecintoObar = saveTurn; 
        });


        let json = this.copyspot.Hotspots[0];

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.hotspot(TAction.acEdit, this.copyspot.Hotspots[0].HotspotID, this.rootile.Profile.ProfileID, json)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.util.populateObj(this.rootspot, this.copyspot),
                erro => this.util.alertPopula(erro, this.rootspot, this.copyspot));

    }

    hotspotFlug(flug: 'tint') {

        let status = this.copyspot.Hotspots[0].HotspotFlag;

        if (flug == 'tint') {
            if (status == THotspotFlag.hfHotspotNenhum)    return this.config.colors.CorMilk;
            if (status == THotspotFlag.hfHotspotTrial)     return this.config.colors.CorMato;
            if (status == THotspotFlag.hfHotspotAberto)    return this.config.colors.CorRoxa;
            if (status == THotspotFlag.hfHotspotLimitado)  return this.config.colors.CorGold;
            if (status == THotspotFlag.hfHotspotBloqueado) return this.config.colors.CorPele;
            if (status == THotspotFlag.hfHotspotSuspenso)  return this.config.colors.CorVerm;
            if (status == THotspotFlag.hfHotspotFechado)   return this.config.colors.CorMenu;
        }

    }

    contratoMenu() {

        if (!this.logado.Profile.ProfileZito) {
            this.util.toastSimply('Acesso negado');
            return;
        }

        let rootrat = null;
        let copyrat = null;
        let contratoID = (!this.rootspot.Hotspots[0].Contrato ? 0 : this.rootspot.Hotspots[0].Contrato.ContratoID);

        if (!contratoID) {
            let servico = {ServicoID: 0, Blended: null, Produto: null, ServicoCash: 0, ServicoCoin: 0, ServicoQtde: 0, ServicoCare: '', ServicoReju: '', ServicoRule: TRuleValue.rvRulePorc, ServicoRate: 0, ServicoBase: TMonth.mnNenhum, ServicoText: ''};
            servico.Blended = {BlendedID: 2001080, BlendedNome: 'Software'};
            servico.Blended.Produto = {ProdutoID: 200108000, ProdutoNome: 'Assinatura'};

            rootrat = {};
            rootrat.HotspotID = this.config.kairos.HotspotID;
            rootrat.HotspotIX = this.copyspot.Hotspots[0].HotspotID;
            rootrat.ContratoID = 0;
            rootrat.ContratoSide = TFinanceSide.cdCredito;
            rootrat.ContratoFato = TPaybookFato.ctVencer;
            rootrat.ContratoFlag = TGeradorFlag.ctAberto;
            rootrat.ContratoNota = false,
            rootrat.ContratoGera = TGeradorLine.glMensal;
            rootrat.ContratoMoon = 0;
            rootrat.ContratoDayz = 0;
            rootrat.ContratoQtde = 0;
            rootrat.ContratoLink = '',
            rootrat.ContratoUser = '',
            rootrat.ContratoPswd = '',
            rootrat.ContratoCria = '',
            rootrat.ContratoStop = '',
            rootrat.Profile = this.util.deepCopy(this.copyspot.Hotspots[0].Empresas[0].Profile);
            rootrat.Negocio = this.util.deepCopy(this.copyspot.Hotspots[0].Branded.Negocio);
            rootrat.Projeto = this.util.deepCopy(this.copyspot.Hotspots[0].Project);
            rootrat.Servicos = [servico];

            copyrat = this.util.deepCopy(rootrat);
        }

        let object = {etapa: 0, contratoID: contratoID, rootrat: rootrat, copyrat: copyrat, rootspot: this.rootspot, copyspot: this.copyspot};
        this.util.modalopen(GeradorMenuPage, 'alto', false, object).subscribe();

    }

    gateweyFlug() {

        if (this.util.manutencao(this.rootile, 'Solicite a nossa equipe a alteração.')) return;

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Parcelamento',  handler: () => this.gateweyQtde()});
        buttons.push({text: 'Taxas',         handler: () => this.gateweyTaxa()});
        buttons.push({text: 'Trocar',        handler: () => this.gateweyEdit()});
        this.util.sheetOpen(buttons, 'GATEWAY');

    }

    gateweyQtde() {

        let onSave = (parc, cash) => {
            this.copyspot.Hotspots[0].HotspotParc = parc;
            this.copyspot.Hotspots[0].HotspotPiso = cash;
            this.hotspotSave();
        };

        let buttons: Array<any> = [];
        buttons.push({text: 'A vista', value: 1});
        for (let i = 2; i <= 12; i++) buttons.push({text: i + 'x', value: i});

        let buttens: Array<any> = [];
        buttens.push({text: 'Acima de', value: 0});
        buttens.push({text: 'R$ 0', value: 0});
        for (let i = 100; i <= 800; i = i + 50) buttens.push({text: this.util.dinheiro(i, false), value: i});

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns.push({name: 'ruut', options: buttens});
        columns[0].selectedIndex = this.copyspot.Hotspots[0].HotspotParc-1;
        columns[1].selectedIndex = (this.copyspot.Hotspots[0].HotspotPiso / 50);
        this.util.pickerOpen(columns, onSave);

    }

    gateweyTaxa() {

    }

    gateweyEdit() {

        let alignL = {type: 'logo', text: '', show: 'BrandedBase', info: '', color: 'CorGold'};
        let alignC = {type: 'text', text: '', show: 'BrandedShow', info: 'BrandedCity', color: ''};
        let alignR = {type: 'bttn', show: 'Pagar', info: '', color: ''};

        let onShow = (show, that, limitPage, reload) => {
            let loading = this.util.loadingDots();
            loading.present();

            this.webstorService.gatewey(TAction.acLoad, this.copyspot.Hotspots[0].HotspotID)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => that.parseArray(data.Gateweys.filter(gate => !!gate.GateweyCent), null, 0, 0, true),
                    erro => this.util.alertResult(erro, () => that.dismiss())
                );
        };

        let onOkuy = (okey, that, line, click, event) => {
            this.copyspot.Hotspots[0].Gatewey = line;
            this.hotspotSave(that);
        };

        let modalshow = this.config.listingForm('Gateway', onShow, onOkuy, alignL, alignC, alignR, 'CorRoxa', null, false, TImageModel.imGatewey);
        let objectData = {profile: this.rootile.Profile, modalshow: modalshow};
        objectData.modalshow.header = 'Gateway';
        objectData.modalshow.titulo = '';
        objectData.modalshow.resumo = '';
        objectData.modalshow.imagem = 'b-icon-arrow-curved';
        objectData.modalshow.molder = '1x1';
        objectData.modalshow.cormain = 'CorAqua';

        this.util.modalopen(ListingMenuPage, 'alto', false, objectData).subscribe();

    }

    partnerMenu(event) {

        //PARTNER-LIST
        if (event == null) {
            let object = {etapa: 2, rootile: this.rootile, partnerID: 0};
            this.util.modalopen(NegocioMenuPage, 'wide', false, object).subscribe(data => {
                if (data) {
                    this.copyspot.Hotspots[0].Partner = data;
                    this.hotspotSave();
                }
            });
        }

        //PARTNER-TOGGLE
        if (event) {
            event.stopPropagation();
            let hotspot = this.copyspot.Hotspots[0];
            hotspot.Partner = (hotspot.Partner ? null : this.util.deepCopy(hotspot.Branded));
            this.hotspotSave();
        }

    }





    /** ************************************************* SETTING ************************************************* **/
    /** ************************************************* etapa-1 ************************************************* **/

    titularMove(edit): any {

        let titular = this.copyspot.Usuarios.find(user => (user.UsuarioRole == TUsuarioRole.urCEO));
        if (!edit) return (titular ? titular.Profile : null);

        //Apenas o Titular
        if (titular.Profile.ProfileID != this.logado.Profile.ProfileID) {
            this.util.toastSimply('Apenas ' + titular.Profile.ProfileShow + ' pode fazer isso.');
            return;
        }

        this.profileRepository.profileFind(null, 'CPF', null, 0, false, false, 'titularidade').subscribe(
            lino => {

                let loading = this.util.loadingDots();
                loading.present();

                this.hotspotService.usuario(TAction.acMove, this.copyspot.Hotspots[0].HotspotID, lino.ProfileID)
                    .finally(() => loading.dismiss())
                    .subscribe(
                        data => {

                            this.util.populateObj(this.rootspot, this.copyspot);
                            this.navCtrl.popToRoot();

                        },
                        erro => {

                            this.util.alertPopula(erro, this.rootspot, this.copyspot);

                        });

            },
            erro => {});

    }

    contratFlug(flug: 'tint' | 'text') {

        if (flug == 'tint') {
            if (!this.copyspot.Hotspots[0].Contrato) return null;
            if (this.copyspot.Hotspots[0].Contrato.ContratoFlag == TGeradorFlag.ctAberto) return 'CorMato';
            if (this.copyspot.Hotspots[0].Contrato.ContratoFlag == TGeradorFlag.ctParado) return 'CorWeek';
            if (this.copyspot.Hotspots[0].Contrato.ContratoFlag >= TGeradorFlag.ctFechou) return 'CorFood';
        }

        if (flug == 'text') {
            if (!this.copyspot.Hotspots[0].Contrato) return 'Nenhum';
            return TGeradorFlag[this.copyspot.Hotspots[0].Contrato.ContratoFlag].slice(2, 99);
        }

    }

    unidadeMenu() {

        let object = {etapa: 0, perfil: this.rootile, rootspot: this.rootspot, copyspot: this.copyspot};
        this.util.modalopen(UnidadeMenuPage, 'alto', false, object).subscribe();

    }

    depositMenu(raiz) {

        let toggler = (raiz ? 'ball' : 'many');
        let itemctrl = (raiz ? null : this.copyspot.Hotspots[0].Deposit);
        let object = {homeb: false, etapa: 0, title: null, keyname: 'Deposit', toggler: toggler, rootspot: this.rootspot, itemctrl: itemctrl, rootctrl: null};
        this.util.modalopen(WebstorOpenPage, 'alto', false, object)
            .finally(() => {
                //if (this.copyspot.Hotspots[0].Deposit) this._setuper = this._setuper + 1;
            })
            .subscribe(
                data => {

                    this.depositSpot(data);

                });

    }

    depositSpot(deposit) {

        if (!this.copyspot.Hotspots[0].HotspotID) {
            this.copyspot.Hotspots[0].Deposit = this.util.deepCopy(deposit);
            this.rootspot.Hotspots[0].Deposit = this.util.deepCopy(deposit);
            this.dismiss();
            return;
        }

        this.copyspot.Hotspots[0].Deposit = this.util.deepCopy(deposit);

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.deposit(TAction.acSpot, deposit.DepositID, this.copyspot.Hotspots[0].HotspotID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    //this.util.populateObj(this.rootspot, this.copyspot);
                    console.log(this.rootspot, this.copyspot);
                    this.dismiss();
                },
                erro => {

                    this.util.alertPopula(erro, this.rootspot, this.copyspot);

                });

    }

    hotspotLota() {

        let onPick = (qtde) => {
            this.copyspot.Hotspots[0].HotspotLota = qtde;
            this.hotspotSave(null);
        };

        let buttons: Array<any> = [];
        buttons.push({text: 'Indefinido', value: 0});

        let index = 0;
        for (let i = 1; i <= 10; i++) {
            let qtde = 100 * i
            if (this.copyspot.Hotspots[0].HotspotLota == qtde) index = i;
            buttons.push({text: this.util.numerico(qtde) + ' pessoas', value: qtde});
        }

        for (let i = 1; i <= 10; i++) {
            let qtde = (200 * i) + 1000
            if (this.copyspot.Hotspots[0].HotspotLota == qtde) index = i;
            buttons.push({text: this.util.numerico(qtde) + ' pessoas', value: qtde});
        }

        for (let i = 1; i <= 12; i++) {
            let qtde = (250 * i) + 3000
            if (this.copyspot.Hotspots[0].HotspotLota == qtde) index = i;
            buttons.push({text: this.util.numerico(qtde) + ' pessoas', value: qtde});
        }

        for (let i = 1; i <= 8; i++) {
            let qtde = (500 * i) + 6000
            if (this.copyspot.Hotspots[0].HotspotLota == qtde) index = i;
            buttons.push({text: this.util.numerico(qtde) + ' pessoas', value: qtde});
        }

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = index;
        this.util.pickerOpen(columns, onPick);

    }

    hotspotJwto() {
    
        let jwto = this.copyspot.Hotspots[0].HotspotJwto;
        
        let onNome = () => {
            let onOkey = (okey, that, data) => {
                onSend(okey.inputf.text, okey, that);
            };

            let objectData = {modalfull: false, modalinfo: this.config.modalinfo(this.util, 'integre', onOkey, onOkey, false)};
            this.util.modalopen(ModalActionPage, 'alto', true, objectData).subscribe();        
        }

        let onSend = (hotspotJwtn, okey?, that?) => {
            
            let onDone = () => {

                if (!okey) return;
                okey.window = 'integra';
                okey.corcor = 'CorLime';
                okey.header = 'Lorean-API';
                okey.titulo = 'PARABÉNS';
                okey.resumo = 'integração criada!';
                okey.imagem = 'b-icon-ok';
                okey.stores = null;
                okey.inputf = null;
                okey.action = null;
                okey.observ = null;
                okey.linhas = null;
            }
    
            this.copyspot.Hotspots[0].HotspotJwto = hotspotJwtn;
            this.copyspot.Hotspots[0].HotspotJwtn = hotspotJwtn;

            let loading = this.util.loadingDots();
            loading.present();
    
            this.hotspotService.hotspot(TAction.acJwto, this.copyspot.Hotspots[0].HotspotID, this.rootile.Profile.ProfileID, null, '&HotspotJwtn=' + hotspotJwtn)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => onDone(),
                    erro => this.util.alertPopula(erro, this.rootspot, this.copyspot));    
        };

        let onCopy = () => {
            this.util.clipboardCopy(jwto);
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        if (!jwto) buttons.push({text: 'Create', handler: () => onNome()});
        if (jwto)  buttons.push({text: 'Remove', handler: () => onSend('')});
        if (jwto)  buttons.push({text: 'Copiar', handler: () => onCopy()});
        this.util.sheetOpen(buttons, 'APIL');

    }

    monitorTeto() {

        let onPick = (teto) => {
            this.copyspot.Hotspots[0].Setting.SettingTeto = teto;
            this.monitorSave();
        };

        let buttons: Array<any> = [];
        buttons.push({text: 'Desativado', value: 0});

        let index = 0;
        for (let i = 1; i <= 20; i++) {
            if (this.copyspot.Hotspots[0].Setting.SettingTeto == (100 * i)) index = i;
            buttons.push({text: this.util.dinheiro(100 * i, false), value: 100 * i});
        }

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = index;
        this.util.pickerOpen(columns, onPick);

    }

    monitorShot() {

        let onSave = (shot) => {
            this.copyspot.Hotspots[0].Setting.SettingShot = shot;
            this.monitorSave();
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: '0 ml',  handler: () => onSave(0)});
        buttons.push({text: '30 ml', handler: () => onSave(30)});
        buttons.push({text: '40 ml', handler: () => onSave(40)});
        buttons.push({text: '50 ml', handler: () => onSave(50)});
        this.util.sheetOpen(buttons, 'SHOT');

    }

    monitorDose() {

        let onSave = (dose) => {
            this.copyspot.Hotspots[0].MonitorDose = dose;
            this.monitorSave();
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: '0 ml',  handler: () => onSave(0)});
        buttons.push({text: '60 ml', handler: () => onSave(60)});
        buttons.push({text: '70 ml', handler: () => onSave(70)});
        buttons.push({text: '80 ml', handler: () => onSave(80)});
        this.util.sheetOpen(buttons, 'DOSE');

    }

    meritumExec() {

        let exist = !!this.copyspot.Hotspots[0].Meritum;
        let buttons: Array<any> = [];
        buttons.push(           {text: 'Alterar', handler: () => this.meritumSend(false)});
        if (exist) buttons.push({text: 'Remover', handler: () => this.meritumSend(true), role: 'destructive'});

        /** OPEN **/
        this.util.sheetOpen(buttons, 'MERITUM');

    }

    meritumSend(clear?) {

        let onConfir = (line?, that?) => {

            let merit = this.copyspot.Hotspots[0].Meritum;
            if (!line && merit) {
                let have = this.copyspot.Meritums.find(mr => (mr.MeritumID == merit.MeritumID));
                this.copyspot.Meritums.splice(0, 0, have);
            }

            if (line) {
                let have = this.copyspot.Meritums.find(mr => (mr.MeritumID == line.MeritumID));
                if (!have) this.copyspot.Meritums.push(line);
            }

            this.copyspot.Hotspots[0].Meritum = line;
            this.hotspotSave(that);
        };

        if (clear) {
            let alerta = TBrandedTipo[this.copyspot.Meritums[0].Branded.BrandedTipo].slice(2, 99) + ' de ' + this.copyspot.Meritums[0].Branded.BrandedNome;
            this.util.alertQuestion('REMOVER?', alerta, 'Sim|Não', () => onConfir(null), false, true, null, null);
            return;
        }

        let alignL = {type: 'logo', text: '', show: 'BrandedSymb', info: '', color: ''};
        let alignC = {type: 'text', text: '', show: 'MeritumNome', info: '', color: ''};
        let alignR = {type: 'none', text: '', show: '',            info: '', color: ''};

        let onShow = (show, that, limitPage, reload) => {

            let loading = this.util.loadingDots();
            loading.present();

            this.webstorService.meritum(TAction.acLoad)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => that.parseArray(data.Meritums),
                    erro => this.util.alertResult(erro, () => that.dismiss())
                );

        };

        let onOkuy = (okey, that, line, click, event) => onConfir(line, that);

        let modalshow = this.config.listingForm('Meritum', onShow, onOkuy, alignL, alignC, alignR, 'CorRoxa', null, false, TImageModel.imMeritum);
        let objectData = {profile: this.logado.Profile, modalshow: modalshow, tabmenu: false};
        this.util.modalopen(ListingMenuPage, 'alto', false, objectData).subscribe();

    }

    integraOpen() {

        let onSave = (brandedID) => {

            if (brandedID == 12350) this.integraFood(12350);
          //if (brandedID == 24416) this.integraPaye(24416);

        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'iFood',  handler: () => onSave(12350)});
        buttons.push({text: 'Elgin',  handler: () => onSave(24416)});
        this.util.sheetOpen(buttons, 'API');

    }

    integraFood(brandedID) {

        let onInit = (json) => {

            //API - Iniciar
            let onOkey = (okey, that, data) => {

                let integraCode = (okey.inputf == null);
                if ( integraCode) this.integraCode(brandedID, okey, that, json);
                if (!integraCode) this.integraDone(brandedID, okey, that);

            };

            let objectData = {modalfull: false, modalinfo: this.config.modalinfo(this.util, 'integra', onOkey, onOkey, false, json.Codigo)};
            this.util.modalopen(ModalActionPage, 'alto', true, objectData).subscribe();

        };

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.integra(TAction.acFood, this.copyspot.Hotspots[0].HotspotID, brandedID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onInit(data),
                erro => this.util.alertResult(erro));

    }

    integraCode(brandedID, okey, that, json) {

        this.util.open(json.Urlink, '_blank');

        okey.window = 'integra';
        okey.corcor = 'CorFood';
        okey.header = 'iFood';
        okey.titulo = 'INFORME O CÓDIGO';
        okey.resumo = 'que eles forneceram no portal.';
        okey.imagem = null;
        okey.stores = null;
        okey.inputf = {name: 'Código de autorização do iFood', mask: 'AAAA-AAAA', type: 'all', size: 9, text: ''};
        okey.action = {name: 'Validar Código', round: false, small: false, plus: null};
        okey.observ = null;
        okey.linhas = [
            {text: '<b>Autorize</b> nosso app no <b>portal iFood</b>.', right: ''},
            {text: null, right: ''},
            {text: 'No portal, você receberá <b>outro código</b>.', right: ''},
            {text: null, right: ''},
            {text: '<b>Copie e cole aqui</b> após autorizar.', right: ''},
        ];

    }

    integraDone(brandedID, okey, that) {
        
        if (!okey.inputf.text || okey.inputf.text.length < 6) {
            this.util.alertSimply('Informe o código de autorização fornecido pelo iFood.', 'API iFood');
            return;
        }

        let onDone = () => {
            okey.window = 'integra';
            okey.corcor = 'CorLime';
            okey.header = 'iFood';
            okey.titulo = 'PARABÉNS';
            okey.resumo = 'integração concluída!';
            okey.imagem = 'b-icon-ok';
            okey.stores = null;
            okey.inputf = null;
            okey.action = null;
            okey.observ = null;
            okey.linhas = null;
        }

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.integra(TAction.acFood, this.copyspot.Hotspots[0].HotspotID, brandedID, okey.inputf.text)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onDone(),
                erro => this.util.alertResult(erro));

    }

    hotspotMail() {

        this.copyspot.Hotspots[0].HotspotMail = this.copyspot.Hotspots[0].HotspotMail.toLowerCase();

    }




    /** ************************************************ MONITOR ************************************************** **/
    /** ************************************************ setuper ************************************************** **/

    monitorSave() {

        let json = this.copyspot.Hotspots[0].Setting;

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.setting(TAction.acSave, this.copyspot.Hotspots[0].HotspotID, json)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.util.populateObj(this.rootspot, this.copyspot),
                erro => this.util.alertPopula(erro, this.rootspot, this.copyspot));

    }

    hotspotBeta() {

        let onNext = (beta) => {
            this.copyspot.Hotspots[0].HotspotBeta = beta;
            this.hotspotSave(null);
        };

        /** OPEN **/
        let arrayEnum = this.util.enumArray(TVersionBeta);
        let buttons: Array<any> = [];
        arrayEnum.forEach(beta => buttons.push({text: beta.slice(2, 99), handler: () => onNext(TVersionBeta[beta])}));
        this.util.sheetOpen(buttons, 'STATUS');

    }

    hotspotQtde() {

        if (!this.logado.Profile.ProfileZito) {
            this.util.toastSimply('Acesso negado');
            return;
        }

        let onPick = (qtde) => {
            this.copyspot.Hotspots[0].HotspotQtde = qtde;
            this.hotspotSave(null);
        };

        let buttons: Array<any> = [];
        for (let i = 0; i < 100; i++) buttons.push({text: i, value: i});

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = this.copyspot.Hotspots[0].HotspotQtde;
        this.util.pickerOpen(columns, onPick);

    }

    monitorStok() {

        let onNext = (view) => {
            this.copyspot.Hotspots[0].Setting.SettingStok = view;
            this.monitorSave();
        };

        /** OPEN **/
        let arrayEnum = this.util.enumArray(TEstoqueView);
        let buttons: Array<any> = [];
        arrayEnum.forEach(view => buttons.push({text: view.slice(2, 99), handler: () => onNext(TEstoqueView[view])}));
        this.util.sheetOpen(buttons, 'MEDIDA');

    }

    monitorLote() {

        let onSave = (lote) => {
            this.copyspot.Hotspots[0].Setting.SettingLote = lote;
            this.monitorSave();
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Não', handler: () => onSave(0)});
        buttons.push({text: '5`',  handler: () => onSave(5)});
        buttons.push({text: '10`', handler: () => onSave(10)});
        buttons.push({text: '15`', handler: () => onSave(15)});
        buttons.push({text: '20`', handler: () => onSave(20)});
        this.util.sheetOpen(buttons, 'TOLERÂNCIA');

    }

    monitorBars() {

        let onPick = (bars) => {
            this.copyspot.Hotspots[0].Setting.SettingBars = bars;
            this.monitorSave();
        };

        let buttons: Array<any> = [];
        for (let i = -5; i <= +5; i++) {
            if (i == 0) buttons.push({text: 'Número', value: i});
            if (i != 0) buttons.push({text: i * 1000, value: i});
        }

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = (this.copyspot.Hotspots[0].Setting.SettingBars + 5);
        this.util.pickerOpen(columns, onPick);

    }

    monitorDedo(auto: boolean) {

        let onSave = (dedo) => {
            this.copyspot.Hotspots[0].Setting.SettingDedo = dedo;
            this.monitorSave();
        };

        if (auto) {
            onSave((this.hotspotDedo ? 50 : 0));
            return;
        }

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: '1.000',      handler: () => onSave(1)});
        buttons.push({text: '20.000',     handler: () => onSave(20)});
        buttons.push({text: '50.000',     handler: () => onSave(50)});
        buttons.push({text: '60.000',     handler: () => onSave(60)});
        buttons.push({text: '70.000',     handler: () => onSave(70)});
        buttons.push({text: '80.000',     handler: () => onSave(80)});
        buttons.push({text: '90.000',     handler: () => onSave(90)});
        this.util.sheetOpen(buttons, 'DIGITAL');

    }

    monitorGorj() {

        let onSave = (gorj) => {
            this.copyspot.Hotspots[0].Setting.SettingGorj = gorj;
            this.monitorSave();
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Liquido', handler: () => onSave(0)});
        buttons.push({text: 'Bruto',   handler: () => onSave(1)});
        this.util.sheetOpen(buttons, 'GORJETA');

    }

    monitorShut() {

        let onSave = (shut) => {
            this.copyspot.Hotspots[0].Setting.SettingShut = shut;
            this.monitorSave();
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Emissor', handler: () => onSave(TWorkdayShut.wsEmissor)});
        buttons.push({text: 'Quitado', handler: () => onSave(TWorkdayShut.wsQuitado)});
        buttons.push({text: 'Devedor', handler: () => onSave(TWorkdayShut.wsDevedor)});
        this.util.sheetOpen(buttons, 'ENCERRAR');

    }

    monitorTela() {

        let onSave = (tela) => {
            this.copyspot.Hotspots[0].Setting.SettingTela = tela;
            this.monitorSave();
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Desativado',  handler: () => onSave(0)});
        buttons.push({text: '10 segundos', handler: () => onSave(10)});
        buttons.push({text: '20 segundos', handler: () => onSave(20)});
        buttons.push({text: '30 segundos', handler: () => onSave(30)});
        buttons.push({text: '40 segundos', handler: () => onSave(40)});
        buttons.push({text: '50 segundos', handler: () => onSave(50)});
        buttons.push({text: '60 segundos', handler: () => onSave(60)});
        this.util.sheetOpen(buttons, 'TIMEOUT-BAR');

    }

    monitorBind() {

        let onNext = (bind) => {
            this.copyspot.Hotspots[0].Setting.SettingBind = bind;
            this.monitorSave();
        };

        /** OPEN **/
        let arrayEnum = this.util.enumArray(TPrinterBind);
        let buttons: Array<any> = [];
        arrayEnum.forEach(bind => buttons.push({text: bind.slice(2, 99), handler: () => onNext(TPrinterBind[bind])}));
        this.util.sheetOpen(buttons, 'BIND');

    }

    escolhaHide() {

        let onBack = () => this.util.statusBarColor(TStatusBar.sbStyleDefault);

        let objectHide = {homeb: false, etapa: 1, title: null, keyname: 'Esconde', toggler: 'many', rootspot: this.rootspot, copyspot: this.copyspot};
        this.util.modalopen(WebstorOpenPage, 'alto', false, objectHide, null, null, onBack).subscribe();

    }

    monitorKode() {

        let onSave = (kode) => {
            this.copyspot.Hotspots[0].Setting.SettingKode = kode;
            this.monitorSave();
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Por grupo',  handler: () => onSave(false)});
        buttons.push({text: 'Por código', handler: () => onSave(true)});
        this.util.sheetOpen(buttons, 'LANÇAMENTO');

    }

    monitorMeio() {

        let onSave = (meio) => {
            this.copyspot.Hotspots[0].Setting.SettingMeio = meio;
            this.monitorSave();
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Desativado',  handler: () => onSave(0)});
        buttons.push({text: '50%',         handler: () => onSave(50)});
        buttons.push({text: '60%',         handler: () => onSave(60)});
        buttons.push({text: '70%',         handler: () => onSave(70)});
        this.util.sheetOpen(buttons, 'METADE');

    }

    monitorHalf() {

        let onPick = (qtde) => {
            this.copyspot.Hotspots[0].Setting.SettingHalf = qtde;
            this.monitorSave();
        };

        let buttons: Array<any> = [];
        for (let i = 1; i <= 10; i++) buttons.push({text: this.util.plural(i, 'comanda'), value: i});

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = this.copyspot.Hotspots[0].Setting.SettingHalf;
        this.util.pickerOpen(columns, onPick);

    }

    monitorDoby() {

        let onNext = (doby) => {
            this.copyspot.Hotspots[0].Setting.SettingDoby = doby;
            this.monitorSave();
        };

        /** OPEN **/
        let arrayEnum = this.util.enumArray(TMonitorDoby);
        let buttons: Array<any> = [];
        arrayEnum.forEach(doby => buttons.push({text: doby.slice(2, 99), handler: () => onNext(TMonitorDoby[doby])}));
        this.util.sheetOpen(buttons, 'DOBRO');

    }

    monitorCoin() {

        let onSave = (coin) => {
            this.copyspot.Hotspots[0].Setting.SettingCoin = coin;
            this.monitorSave();
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Desativado',  handler: () => onSave(0)});
        buttons.push({text: '1 mês',       handler: () => onSave(1)});
        buttons.push({text: '2 meses',     handler: () => onSave(2)});
        buttons.push({text: '3 meses',     handler: () => onSave(3)});
        buttons.push({text: '6 meses',     handler: () => onSave(6)});
        buttons.push({text: '12 meses',    handler: () => onSave(12)});
        this.util.sheetOpen(buttons, 'VALIDADE');

    }

    monitorClub() {

        let onSave = (club) => {
            this.copyspot.Hotspots[0].Setting.SettingClub = club;
            this.monitorSave();
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Desativado',  handler: () => onSave(0)});
        buttons.push({text: '1 mês',       handler: () => onSave(1)});
        buttons.push({text: '2 meses',     handler: () => onSave(2)});
        buttons.push({text: '3 meses',     handler: () => onSave(3)});
        buttons.push({text: '6 meses',     handler: () => onSave(6)});
        this.util.sheetOpen(buttons, 'VALIDADE');

    }

    monitorUnir() {

        let onNext = (unir) => {
            this.copyspot.Hotspots[0].Setting.SettingUnir = unir;
            this.monitorSave();
        };

        /** OPEN **/
        let arrayEnum = this.util.enumArray(TMonitorUnir);
        let buttons: Array<any> = [];
        arrayEnum.forEach(unir => buttons.push({text: 'Preço ' + unir.slice(2, 99), handler: () => onNext(TMonitorUnir[unir])}));
        this.util.sheetOpen(buttons, 'PREÇO UNIR');

    }

    monitorMail(index) {

        let array = this.copyspot.Hotspots[0].Setting.SettingMail.split(';').filter(Boolean);
        array.splice(index, 1);

        this.copyspot.Hotspots[0].Setting.SettingMail = array.join(';');
        this.monitorSave();

    }

    profileAlma() {

        let onNext = (alma) => {
            this.copyspot.Hotspots[0].Setting.SettingAlma = alma;
            this.monitorSave();
        };

        /** OPEN **/
        let arrayEnum = this.util.enumArray(TProfileAlma);
        let buttons: Array<any> = [];
        arrayEnum.forEach(flag => buttons.push({text: flag.slice(2, 99), handler: () => onNext(TProfileAlma[flag])}));
        this.util.sheetOpen(buttons, 'VISITANTE');

    }



    /** ************************************************* WORKDAY ************************************************* **/
    /** ************************************************* etapa-2 ************************************************* **/

    workdayFixo() {

        let onSave = (fixo) => {

            //Random limpa code
            if (!fixo) {
                this.copyspot.Hotspots[0].HotspotFixo = false;
                this.copyspot.Hotspots[0].HotspotCode = '';
                this.hotspotSave(null);
                return;
            }


            //Fixo abre janela
            let onOkey = (okey, that, data) => {
                this.copyspot.Hotspots[0].HotspotFixo = true;
                this.copyspot.Hotspots[0].HotspotCode = okey.inputf.text;
                this.hotspotSave(that);
            };

            let objectData = {modalfull: false, modalinfo: this.config.modalinfo(this.util, 'codeday', onOkey, onOkey)};
            this.util.modalopen(ModalActionPage, 'alto', true, objectData).subscribe();

        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Fixo',   handler: () => onSave(true)});
        buttons.push({text: 'Random', handler: () => onSave(false)});
        this.util.sheetOpen(buttons, 'CODEDAY');

    }




    /** ************************************************* GALERIA ************************************************* **/
    /** ************************************************* etapa-4 ************************************************* **/


    networkInfo() {

        this.detail = !this.detail;
        this.util.vibrate(50);

    }

    keyspotEdit() {

        let igual = (this.copyspot.Hotspots[0].HotspotSpot == this.rootspot.Hotspots[0].HotspotSpot);
        if (igual || this.copyspot.Hotspots[0].HotspotSpot.length < 24) return;
        this.monitorSave();

    }

    clipshare(field) {

        this.util.clipboardCopy(this.copyspot.Hotspots[0][field], field + ' copiado!');

        // if ( only this.util.nativeApp() ???? ) {
        //     import {Clipboard} from "@ionic-native/clipboard";
        //     private clipboard: Clipboard
        //     this.clipboard.copy(this.copyspot.Hotspots[0][field]);
        //     this.util.toastSimply(field + ' copiado!');
        //     return;
        // }

        this.socialSharing.share(this.copyspot.Hotspots[0][field], field);

    }

    dismiss() {

        if ( this.viewCtrl.isOverlay) this.viewCtrl.dismiss();
        if (!this.viewCtrl.isOverlay) this.navCtrl.pop();

    }

    
    
}



// WEBPACK FOOTER //
// ./src/pages/sync/setting-menu/setting-menu.ts